import cn from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import { InteractiveDiv } from '@Components/InteractiveEl';

interface CustomerInsightsLegendProps {
  data: {
    name: string;
    val1: string;
    val2?: string;
    computedValue: string;
    color?: string;
  }[];
  hoveredValue?: string;
  setHoveredValue?: Dispatch<SetStateAction<string | undefined>>;
  selectedValue?: string;
  setSelectedValue?: Dispatch<SetStateAction<string | undefined>>;
}

export const CustomerInsightsLegend = ({
  data,
  hoveredValue,
  setHoveredValue,
  selectedValue,
  setSelectedValue
}: CustomerInsightsLegendProps) => (
  <div className='legend'>
    {data.map(({ name, val1, val2, computedValue, color }) => (
      <InteractiveDiv
        key={name}
        className={cn('legend-item', {
          'hovered-value': name === hoveredValue,
          'unhovered-value': Boolean(hoveredValue) && name !== hoveredValue,
          'selected-value': !hoveredValue && name === selectedValue,
          'unselected-value': !hoveredValue && Boolean(selectedValue) && name !== selectedValue
        })}
        onMouseEnter={setHoveredValue ? () => setHoveredValue(name) : undefined}
        onMouseLeave={setHoveredValue ? () => setHoveredValue(undefined) : undefined}
        onClick={
          setSelectedValue
            ? () => setSelectedValue(name === selectedValue ? undefined : name)
            : undefined
        }
      >
        {color && <div className='item-color' style={{ backgroundColor: color }} />}
        <div className='item-label'>
          <div>{name}</div>
        </div>
        <div className='item-computed-value'>{computedValue}</div>
        <div className='stacked-item-values'>
          {val1 && <div className='item-value'>{val1}</div>}
          {val2 && <div className='item-value'>{val2}</div>}
        </div>
      </InteractiveDiv>
    ))}
  </div>
);
